import configFactory from './CommerceCheckoutStripeElement';
export default configFactory('cardCvc');
